<template>
  <div>
    <div class="top">
      <Breadcrumb :options="breadcrumb" />
    </div>

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #start>
        <!-- 车头/挂车筛选 -->
        <FormItem v-show="showTypeCtrl" :config="typeCtrl" :options="typeCtrl.options"
          :inputValue="formInline[typeCtrl.keyName]" @onChange="onTypeChange" />

        <!-- <el-form-item class="startBtn">
          <el-button type="primary" @click="addItem" icon="el-icon-plus">添加</el-button>
        </el-form-item> -->
      </template>
      <!-- 表头设置控件 -->
      <!-- <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template> -->
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :btns="btns"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange">
      <template slot="btn1" slot-scope="params">
        <el-button class="positionbtn" type="primary" @click="goGx(params.params)" size="mini">更新</el-button>
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "VehicleHang",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: '/inspection',
      breadcrumb: [
        { name: "车辆管理", path: `/vehicle/inspect` },
        { name: "车辆年检", path: `/vehicle/inspect` },
      ],
      showTypeCtrl: false,
      typeCtrl: {
        label: "种类",
        keyName: "car_type",
        placeholder: "请选择种类",
        type: "select",
        options: [
          { label: '全部', value: null },
          { label: '车头', value: 1 },
          { label: '挂车', value: 2 },
        ],
      },
      formCtrl: [
        {
          ...this.ctrls.fleet,
          options: [],
        },
        {
          label: "车牌号",
          keyName: "license",
          placeholder: "请填写车牌号",
          type: "text",
        },
        {
          label: "最近一次年检时间",
          keyName: "last_inspection_at",
          placeholder: "请选择开始结束时间",
          type: "daterange",
          options: [],
        },
        {
          label: "下次年检时间",
          keyName: "next_inspection_at",
          placeholder: "请选择开始结束时间",
          type: "daterange",
          options: [],
        },
      ],
      cols: [
        { keyName: "license", label: "车牌号", minwidth: 120 },
        { keyName: "vtype", label: "车辆类型", className: 'pr30', minwidth: 120 },
        { keyName: "inspection_at", label: "最近一次年检时间", minwidth: 120 },
        { keyName: "cost", label: "最近一次年检费用", minwidth: 120 },
        { keyName: "institution", label: "年检机构", minwidth: 120 },
        { keyName: "next_inspection_at", label: "下次年检时间", minwidth: 120 },
        { keyName: "updated_at", label: "更新时间", minwidth: 120 },
        { keyName: "", label: "更新年检", slot: 'btn1', minwidth: 120 },
      ],
      btns: [
        {
          ...this.viewBtn,
          title: "查看",
          cb: ({ id, car_type }) => {
            this.$router.push(
              `/vehicle/inspectdetail?id=${id}&car_type=${car_type}`
            );
          },
        },
        {
          class: 'insurancebtn',
          img: require('@/assets/img/icon-jian.png'),
          unimg: require('@/assets/img/icon-jian-hover.png'),
          title: '年检记录',
          cb: ({ id, car_type }) => {
            this.$router.push(`/vehicle/inspecttables?id=${id}&car_type=${car_type}`);
          },
        },
      ],
      baseParams: ['car_type'],
    };
  },
  methods: {
    tableDataHandler({ count, data }) {
      this.total = count
      if (data && data.length) {
        this.tableData = data.map(v => {
          const obj = this.dataObjHandler(v)
          obj.DISABLED = !(obj.inspection_at)
          // console.log({ ...obj })
          return obj
        })
      }
      // console.log(this.tableData)
    },
    onReset() {
      console.log("onReset");
      // console.log({ ...this.formInline })
      // 为所有字段设置初始值
      const obj = {}
      this.formCtrl.map(v => {
        obj[v.keyName] = null
      })
      this.searchKeyOptions.map(v => {
        obj[v.value] = null
      })
      this.baseParams.map(v => {
        if (v == 'car_type') {
          if (this.showTypeCtrl) {
            obj[v] = null
          } else {
            obj[v] = this.formInline[v]
          }
        }
      })
      // console.log(obj)
      this.formInline = obj;
      this.$forceUpdate()
      // 清除储存的搜索条件
      const path = this.$route.path
      this.setStore({
        ['formInline' + path]: obj,
      })
      // 回到首页
      this.page = 1;
      // 请求
      this.getList();
      // console.log({ ...this.formInline })
    },
    goGx({ id, license, vtype, car_type }) {
      // console.log(p)
      this.$router.push(`/vehicle/inspectview?mode=edit&license=${license}&vtype=${vtype}&id=${id}&car_type=${car_type}`);
    },
    onTypeChange({ key, value }) {
      console.log(key, value)
      this.formInline[key] = value;
      console.log({ ...this.formInline });
      this.page = 1;
      this.getList()
    },
    getInspectionSet() {
      let url = `base/isInspection`
      const params = {
        inspection: 2,
      }
      this.post(url, params, (res) => {
        // console.log('res', res, typeof res)
        if (res === true) {
          this.showTypeCtrl = true
          // console.log('showTypeCtrl', this.showTypeCtrl)
          this.$set(this.formInline, 'car_type', null)
        } else {
          this.$set(this.formInline, 'car_type', 1)
        }
        this.page = 1;
        this.getList()
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交数据失败，请稍后重试！'
        });
      })
    },
  },
  created() {
    const { user_group_id, id } = this.user
    if (user_group_id == 1) {
      this.btns[0] = {
        ...this.editBtn,
        cb: ({ id, car_type }) => {
          this.$router.push(
            `/vehicle/inspectdetail?id=${id}&car_type=${car_type}&mode=edit`
          );
        },
      }
    } else if (user_group_id == 5) {
      this.formInline.fleet = id
      this.formCtrl.splice(0, 1)
      this.baseParams.push('fleet')
    }
  },
  mounted() {
    this.getFleet();
    this.getInspectionSet();
    const { user_group_id } = this.user
    if (user_group_id == 5) {
      // 由于本身没有baseParams，有了baseParams手动触发首次请求
      this.getList();
    }
  },
};
</script>
<style lang="less" scoped>
/deep/ .dialog {
  .el-form {

    .el-input,
    .el-textarea {
      width: 230px;
    }
  }

  .btns .mians {
    text-align: center;
  }
}

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 20px;
}
</style>